import React from "react";
import { Space, Typography } from "antd";
import Breadcrumbs from "../headers/Breadcrumbs";
import PropTypes from "prop-types";
import background from "../../assets/background.jpg";

const { Text, Title } = Typography;

const SiteHeader = ({ title, subTitle }) => (
  <>
    <div
      style={{
        width: "auto",
        padding: "0 0 24px 24px",
        color: "#fff",
        background:
          "linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.04) 100%), url(" +
          background +
          ") no-repeat center center",
        backgroundSize: "cover",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: 8,
      }}
    >
      <Space direction="vertical" align="left" size={4}>
        <div
          style={{
            padding: "14px 4px 0 4px",
          }}
        >
          <Breadcrumbs />
        </div>
        <Title
          level={1}
          style={{
            marginBottom: 0,
            color: "rgb(255, 255, 255)",
            fontSize: "2rem",
            fontWeight: 600,
          }}
        >
          {title}
        </Title>
        {subTitle && (
          <Text
            style={{
              color: "rgba(255, 255, 255, 0.85)",
              fontSize: "1rem",
            }}
          >
            {subTitle}
          </Text>
        )}
      </Space>
    </div>
  </>
);

SiteHeader.propTypes = {
  breadcrumbs: PropTypes.array,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default SiteHeader;
